export default __webpack_public_path__ + "static/media/MinnieMad.03358733.jpg";